import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'
import Auth from '../views/Auth.vue'
import GenericalView from '../views/GenericalView.vue'
import ResetPassword from '../views/ResetPassword.vue'

const routes = [
    {
        path: '/',
        name: 'Auth',
        component: Auth
    },
    {
        path: '/reset/password',
        name: 'ResetPassword',
        component: ResetPassword
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('../views/Dashboard.vue'),
        meta: { requiresAuth: true, permission: ['administrador', 'pesquisador'] },
        children: [

            // Lojas
            {
                path: 'lojas',
                name: 'LojasView',
                component: GenericalView,
                meta: { permission: ['administrador', 'pesquisador'] },
                children: [
                    {
                        path: 'adesao',
                        name: 'LojasAdesao',
                        component: () => import('../components/Loja/LojasAdesao.vue'),
                        meta: { permission: ['administrador', 'pesquisador'] }
                    },
                    {
                        path: 'ativas',
                        name: 'LojasAtivasView',
                        component: GenericalView,
                        meta: { permission: ['administrador', 'pesquisador'] },
                        children: [
                            {
                                path: '',
                                name: 'LojasAtivas',
                                component: () => import('../components/Loja/LojasAtivas.vue'),
                                meta: { permission: ['administrador', 'pesquisador'] }
                            },
                            {
                                path: ':id',
                                name: 'DetalheAtivasView',
                                component: GenericalView,
                                meta: { permission: ['administrador', 'pesquisador'] },
                                children: [
                                    {
                                        path: '',
                                        name: 'DetalheAtivas',
                                        component: () => import('../components/Loja/DetalheLoja.vue'),
                                        meta: { permission: ['administrador', 'pesquisador'] }
                                    },
                                    {
                                        path: 'recolha/:anomes',
                                        name: 'DetalheRecolhas',
                                        component: () => import('../components/Loja/DetalheRecolhas.vue'),
                                        meta: { permission: ['administrador', 'pesquisador'] }
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        path: 'nova',
                        name: 'NovaLoja',
                        component: () => import('../components/Loja/NovaLoja.vue'),
                        meta: { permission: ['administrador', 'pesquisador'] }
                    }
                ]
            },

            // Produtos
            { path: 'produtos', name: 'ListaProdutos', component: () => import('../components/Produtos/ListaProdutos.vue'), meta: { permission: ['administrador', 'pesquisador'] } },
            { path: 'produtos/loja/:id', name: 'ProdutosLoja', component: () => import('../components/Produtos/ProdutosLoja.vue'), meta: { permission: ['administrador', 'pesquisador'] } },
            { path: 'produtos/novo', name: 'CriarProduto', component: () => import('../components/Produtos/CriarProduto.vue'), meta: { permission: ['administrador', 'pesquisador'] } },

            { path: 'recolha/:cnpj', name: 'Pesquisa', component: () => import('../components/Pesquisa/Pesquisa.vue'), meta: { permission: ['administrador', 'pesquisador'] } },
            { path: 'recolha/pesquisa/:id', name: 'ProcurarRecolha', component: () => import('../components/Pesquisa/ProcurarRecolha.vue'), meta: { permission: ['administrador', 'pesquisador'] } },

            // Pessoas
            { path: 'usuarios', name: 'ListaUsuarios', component: () => import('../components/Usuarios/Users.vue'), meta: { permission: ['administrador'] } },
            { path: 'usuarios/novo', name: 'CriarUsuarios', component: () => import('../components/Usuarios/CriarUsuarios.vue'), meta: { permission: ['administrador'] } },
            { path: 'usuarios/perfil/:id', name: 'Profile', component: () => import('../views/User.vue'), meta: { permission: ['administrador', 'owner'] } },

            // Metricas
            { path: 'exportar/recolhas', name: 'ExportarRecolhas', component: () => import('../components/Metricas/ExportarRecolhas.vue'), meta: { permission: ['administrador'] } },
            { path: 'exportar/ativas', name: 'ExportarAtivas', component: () => import('../components/Metricas/ExportarAtivas.vue'), meta: { permission: ['administrador'] } },
            { path: 'resultados/importacao', name: 'ResultadosImportacao', component: () => import('../components/Metricas/ResultadosImportacao.vue'), meta: { permission: ['administrador'] } },
            { path: 'auditoria', name: 'Auditoria', component: () => import('../components/Metricas/Auditoria.vue'), meta: { permission: ['administrador', 'pesquisador'] } }
        ]
    },
    // {
    //   path: '/usuario/:id',
    //   name: 'UserView',
    //   component: () => import('../views/User.vue'),
    //   meta: { requiresAuth: true, permission: ['administrador', 'pesquisador']},
    // },
    {
        path: '/:catchAll(.*)',
        component: () => import('../views/NotFound.vue')
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters['auth/authenticated']) {
            if (to.meta.permission.includes(store.getters['auth/user'].role)) {
                next()
            } else {
                if (parseInt(to.params.id) === parseInt(store.getters['auth/user'].id)) {
                    next()
                } else {
                    next('/auth/nao/autorizado')
                }
            }
        } else {
            next('/')
        }
    } else {
        next()
    }
})

export default router
